import request from "@/utils/cmsRequest";

export function verifyOTP(data) {
  return request({
    url: "/for_cms/login_with_otp",
    method: "post",
    data
  });
}

export function getInfo(token) {
  return request({
    url: "/admin/detail",
    method: "get",
    data: { token }
  });
}

export function logout() {
  return request({
    url: "admin/logout",
    method: "post"
  });
}

export function getOTP(data) {
  return request({
    url: "for_cms/get_sms_login",
    method: "post",
    data
  });
}

export function getCaptcha(param) {
  return request({
    url: "admin/get-captcha",
    method: "get",
    params: param
  });
}

export function verifyCaptcha(param) {
  return request({
    url: "/admin/verify-captcha",
    method: "get",
    params: param
  });
}

export function loginWap(data) {
  return request({
    url: "/for_wap/mapping_account_vgs",
    method: "post",
    data
  });
}

export function verifyOtpLogin(data) {
  return request({
    url: "for_wap/get_token_with_otp",
    method: "post",
    data
  });
}
